<template>
  <section class="v2026-queue">
    <div class="v2026-queue-title">
      <span class="v2026-queue-title-text" :title="queueTitle">{{ queueTitle }}</span>
      <button class="v2026-queue-collapse"
              @click="$emit('onToggleQueue')"
              aria-label="ซ่อนรายการคิว"
              title="ซ่อนรายการคิว">
        <span class="v2026-queue-collapse-ico"></span>
      </button>
    </div>
    <div class="v2026-queue-list">
      <div role="button"
           class="v2026-queue-row"
           :class="{ 'is-selected': activeMenu === 'inbox' }"
           @click="onMenuClick('inbox')">
        <span v-if="queueIcons.inbox" class="v2026-queue-svg-mask" aria-hidden="true"
              :style="{ '-webkit-mask-image': 'url(' + queueIcons.inbox + ')', 'mask-image': 'url(' + queueIcons.inbox + ')' }"></span>
        <i v-else class="fa fa-inbox v2026-queue-icon"></i>
        <span class="v2026-queue-label" title="ถาดขาเข้า">ถาดขาเข้า</span>
        <span class="v2026-queue-count" v-if="inboxCount">{{ inboxCount }}</span>
      </div>
      <div v-if="['customer'].includes(customerType)"
           role="button"
           class="v2026-queue-row"
           :class="{ 'is-selected': activeMenu === 'reminder' }"
           @click="onMenuClick('reminder')">
        <span v-if="queueIcons.reminder" class="v2026-queue-svg-mask" aria-hidden="true"
              :style="{ '-webkit-mask-image': 'url(' + queueIcons.reminder + ')', 'mask-image': 'url(' + queueIcons.reminder + ')' }"></span>
        <i v-else class="fas fa-bell v2026-queue-icon"></i>
        <span class="v2026-queue-label" title="เตือนนัดหมาย">เตือนนัดหมาย</span>
        <template v-if="reminderSplit.customer">
          <span class="v2026-queue-upcoming" v-if="reminderSplit.customer.upcoming" title="รอเตือน"><i class="far fa-clock" aria-hidden="true"></i>{{ reminderSplit.customer.upcoming }}</span>
          <span class="v2026-queue-count" v-if="reminderSplit.customer.due" title="ถึงเวลาแล้ว">{{ reminderSplit.customer.due }}</span>
        </template>
        <span class="v2026-queue-count" v-else-if="reminderCount">{{ reminderCount }}</span>
      </div>
      <div v-if="['professional'].includes(customerType)"
           role="button"
           class="v2026-queue-row"
           :class="{ 'is-selected': activeMenu === 'reminder' }"
           @click="onMenuClick('reminder')">
        <span v-if="queueIcons.reminder" class="v2026-queue-svg-mask" aria-hidden="true"
              :style="{ '-webkit-mask-image': 'url(' + queueIcons.reminder + ')', 'mask-image': 'url(' + queueIcons.reminder + ')' }"></span>
        <i v-else class="fas fa-bell v2026-queue-icon"></i>
        <span class="v2026-queue-label" title="เตือนนัดหมาย">เตือนนัดหมาย</span>
        <template v-if="reminderSplit.professional">
          <span class="v2026-queue-upcoming" v-if="reminderSplit.professional.upcoming" title="รอเตือน"><i class="far fa-clock" aria-hidden="true"></i>{{ reminderSplit.professional.upcoming }}</span>
          <span class="v2026-queue-count" v-if="reminderSplit.professional.due" title="ถึงเวลาแล้ว">{{ reminderSplit.professional.due }}</span>
        </template>
        <span class="v2026-queue-count" v-else-if="reminderProfessionalCount">{{ reminderProfessionalCount }}</span>
      </div>
      <div role="button"
           class="v2026-queue-row"
           :class="{ 'is-selected': activeMenu === 'active' }"
           @click="onMenuClick('active')">
        <span v-if="queueIcons.inService" class="v2026-queue-svg-mask" aria-hidden="true"
              :style="{ '-webkit-mask-image': 'url(' + queueIcons.inService + ')', 'mask-image': 'url(' + queueIcons.inService + ')' }"></span>
        <i v-else class="fas fa-comments v2026-queue-icon"></i>
        <span class="v2026-queue-label" title="กำลังให้บริการ">กำลังให้บริการ</span>
        <span class="v2026-queue-count" v-if="activeCount">{{ activeCount }}</span>
      </div>
      <div v-if="myAdminId"
           role="button"
           class="v2026-queue-row"
           :class="{ 'is-selected': activeMenu === 'my_inbox' }"
           @click="onMenuClick('my_inbox')">
        <img v-if="myAvatar" class="v2026-queue-avatar" :src="myAvatar" alt="" aria-hidden="true"
             @error="myAvatarFailed = true">
        <i v-else class="fas fa-user-check v2026-queue-icon"></i>
        <span class="v2026-queue-label" title="รับเคสแล้ว">รับเคสแล้ว</span>
        <span class="v2026-queue-count is-unread" v-if="myInboxUnreadCount" title="ลูกค้าตอบกลับ ยังไม่ได้เปิดอ่าน">{{ myInboxUnreadCount }}</span>
        <span class="v2026-queue-count is-mine" v-if="myInboxCount" title="เคสที่รับไว้ทั้งหมด">{{ myInboxCount }}</span>
      </div>
      <div role="button"
           class="v2026-queue-row"
           :class="{ 'is-selected': activeMenu === 'resolved' }"
           @click="onMenuClick('resolved')">
        <span v-if="queueIcons.closedCase" class="v2026-queue-svg-mask" aria-hidden="true"
              :style="{ '-webkit-mask-image': 'url(' + queueIcons.closedCase + ')', 'mask-image': 'url(' + queueIcons.closedCase + ')' }"></span>
        <i v-else class="fas fa-archive v2026-queue-icon"></i>
        <span class="v2026-queue-label" title="ปิดเคส">ปิดเคส</span>
      </div>
      <div role="button"
           class="v2026-queue-row"
           :class="{ 'is-selected': activeMenu === 'line' }"
           @click="onMenuClick('line')">
        <span v-if="queueIcons.line" class="v2026-queue-svg-mask" aria-hidden="true"
              :style="{ '-webkit-mask-image': 'url(' + queueIcons.line + ')', 'mask-image': 'url(' + queueIcons.line + ')' }"></span>
        <i v-else class="fab fa-line v2026-queue-icon"></i>
        <span class="v2026-queue-label" title="Line">Line</span>
      </div>
      <div role="button"
           class="v2026-queue-row"
           :class="{ 'is-selected': activeMenu === 'facebook' }"
           @click="onMenuClick('facebook')">
        <span v-if="queueIcons.facebook" class="v2026-queue-svg-mask" aria-hidden="true"
              :style="{ '-webkit-mask-image': 'url(' + queueIcons.facebook + ')', 'mask-image': 'url(' + queueIcons.facebook + ')' }"></span>
        <i v-else class="fab fa-facebook-messenger v2026-queue-icon"></i>
        <span class="v2026-queue-label" title="Facebook">Facebook</span>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { RAIL_LABELS } from '@/constants/railTypes'

export default {
  name: 'queue-menu-v2026',
  props: {
    filteredMenuCount: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      inboxCount: 0,
      activeCount: 0,
      reminderCount: 0,
      reminderProfessionalCount: 0,
      // เมนู "รับเคสแล้ว": นับแยกต่อ customer_type จาก /menu-count?my_admin_id= (menuCount ของ socket เป็นยอดรวมทุกคน ไม่มีตัวนี้)
      myInboxCounts: {},
      // id เคส "รับเคสแล้ว" ของตัวเอง จาก /menu-count?my_admin_id= — null = server เก่าไม่ส่งมา → ใช้วิธีเดิม
      myInboxIds: null,
      // ตัวเลขแดง "รับเคสแล้ว": เคสของตัวเองที่ลูกค้าตอบกลับแต่ยังไม่ได้เปิดอ่าน (แยกต่อ customer_type)
      myInboxUnreadCounts: {},
      // id ของเคสเหล่านั้น — null = server เก่าไม่ส่งมา → ไม่แสดงตัวเลขแดง
      myInboxUnreadIds: null,
      myInboxTimer: null,
      myAvatarFailed: false,
      // Build-resolved svg URLs painted via CSS mask. No svg → the template falls back to a glyph.
      queueIcons: {
        inbox: require('@/assets/icons2026/inbox.svg'),
        reminder: require('@/assets/icons2026/reminder.svg'),
        inService: require('@/assets/icons2026/in-service.svg'),
        closedCase: require('@/assets/icons2026/closed-case.svg'),
        line: require('@/assets/icons2026/line.svg'),
        facebook: require('@/assets/icons2026/facebook.svg')
      }
    }
  },
  computed: {
    ...mapState('menu', ['menuCount', 'type']),
    // เตือนนัดหมายแยกสองตัวเลข: แดง = ถึงเวลาแล้ว, เทา = รอเตือน
    // null = server เก่ายังไม่ส่ง *DueCount → แสดงยอดรวมตัวเดียวแบบเดิม
    reminderSplit () {
      const mc = this.currentMenuCount
      if (!mc || typeof mc.reminderCustomerDueCount !== 'number') {
        return { customer: null, professional: null }
      }
      return {
        customer: { due: mc.reminderCustomerDueCount, upcoming: mc.reminderCustomerUpcomingCount },
        professional: { due: mc.reminderProfessionalDueCount, upcoming: mc.reminderProfessionalUpcomingCount }
      }
    },
    ...mapState('admin', ['admin']),
    ...mapState('conversation', ['customerType']),
    myAdminId () {
      return this.admin && this.admin.id ? this.admin.id : null
    },
    myAvatar () {
      const src = this.admin && typeof this.admin.profile_picture === 'string' ? this.admin.profile_picture.trim() : ''
      return src && !this.myAvatarFailed ? src : null
    },
    myInboxCount () {
      return this.myInboxCounts[this.customerType] || 0
    },
    myInboxUnreadCount () {
      return this.myInboxUnreadCounts[this.customerType] || 0
    },
    // Shares RAIL_LABELS with the Home rail so the heading always matches the active rail.
    queueTitle () {
      return RAIL_LABELS[this.customerType] || 'แชท'
    },
    currentMenuCount () {
      if (this.isRecruitmentCustomerType(this.customerType) && this.filteredMenuCount) {
        return this.filteredMenuCount
      }

      return this.menuCount
    },
    activeMenu: {
      get () {
        return this.$store.state.menu.type
      },
      set (value) {
        this.$store.commit('menu/SET_TYPE_MENU', value)
      }
    }
  },
  watch: {
    customerType () {
      if (!this.$route.params.id) {
        this.activeMenu = 'inbox'
      }
      this.loadConversations(this.activeMenu, true)
      this.checkConversationCount()
    },
    menuCount () {
      this.checkConversationCount()
      // menuCount เปลี่ยนทุก event แชทของทั้งระบบ — ใช้เป็นสัญญาณเฉพาะตอน server ไม่ส่ง myInboxIds
      // ปกติไปนับใหม่ที่ checkMyInboxChange แทน (เฉพาะเคสเข้า/ออกจากมือ)
      if (this.myInboxIds === null) {
        this.scheduleMyInboxCount()
      }
    },
    filteredMenuCount () {
      this.checkConversationCount()
    }
  },
  methods: {
    ...mapActions('chatTopic', ['fetchParentChatTopics']),
    ...mapActions('menu', ['fetchMenuCount']),
    ...mapActions('tag', ['fetchSystemTags']),
    isRecruitmentCustomerType (customerType) {
      return ['recruitment_customer', 'recruitment_professional', 'recruitment_professional_secondary'].includes(customerType)
    },
    updateActiveMenuCount (value) {
      this.activeCount = value
    },
    // หน่วงไว้: event มาเป็นชุด ยิงครั้งเดียวหลังนิ่ง
    scheduleMyInboxCount (delay = 1500) {
      clearTimeout(this.myInboxTimer)
      this.myInboxTimer = setTimeout(this.fetchMyInboxCount, delay)
    },
    async fetchMyInboxCount () {
      if (!this.myAdminId) {
        return
      }
      try {
        const result = await this.fetchMenuCount({ params: { my_admin_id: this.myAdminId }, commitToStore: false })
        this.myInboxCounts = (result && result.myInboxCounts) || {}
        this.myInboxIds = result && Array.isArray(result.myInboxIds) ? result.myInboxIds.map(Number) : null
        this.myInboxUnreadCounts = (result && result.myInboxUnreadCounts) || {}
        this.myInboxUnreadIds = result && Array.isArray(result.myInboxUnreadIds) ? result.myInboxUnreadIds.map(Number) : null
      } catch (err) {
        // ตัวเลขเมนูไม่ใช่งานหลัก — พลาดก็คงค่าเดิมไว้
      }
    },
    // นับใหม่เฉพาะเมื่อเคสนี้ "เข้า" หรือ "ออก" จากเมนูรับเคสแล้วของตัวเอง (where เดียวกับ getMyInboxCounts)
    checkMyInboxChange (data) {
      const conversation = data && data.conversation
      if (!conversation || !this.myAdminId || this.myInboxIds === null) {
        return
      }
      const isMine = Number(conversation.admin_id) === Number(this.myAdminId) && !Number(conversation.is_archived)
      const wasMine = this.myInboxIds.includes(Number(conversation.id))
      // ตัวเลขแดง: เคสของตัวเองเปลี่ยนสถานะอ่าน (ลูกค้าตอบเข้ามา / เปิดอ่านแล้ว) — where เดียวกับ getMyInboxUnread
      const isUnread = isMine && Number(conversation.unread_count) >= 1
      const wasUnread = this.myInboxUnreadIds !== null && this.myInboxUnreadIds.includes(Number(conversation.id))
      if (isMine !== wasMine || (this.myInboxUnreadIds !== null && isUnread !== wasUnread)) {
        this.scheduleMyInboxCount()
      }
    },
    checkConversationCount () {
      this.inboxCount = 0
      this.activeCount = 0
      this.reminderCount = 0
      this.reminderProfessionalCount = 0

      if (this.currentMenuCount) {
        if (this.customerType === 'customer') {
          this.inboxCount = this.currentMenuCount.inboxCustomerCount
          this.activeCount = this.currentMenuCount.activeCustomerCount
          this.reminderCount = this.currentMenuCount.reminderCustomerCount
        } else if (this.customerType === 'professional') {
          this.inboxCount = this.currentMenuCount.inboxProfessionalCount
          this.activeCount = this.currentMenuCount.activeProfessionalCount
          this.reminderProfessionalCount = this.currentMenuCount.reminderProfessionalCount
        } else if (this.customerType === 'beneat_professional') {
          this.inboxCount = this.currentMenuCount.inboxBeneatProfessionalCount || 0
          this.activeCount = this.currentMenuCount.activeBeneatProfessionalCount || 0
        } else if (this.customerType === 'sales_product_customer') {
          this.inboxCount = this.currentMenuCount.inboxSalesProductCustomerCount || 0
          this.activeCount = this.currentMenuCount.activeSalesProductCustomerCount || 0
        } else if (this.customerType === 'recruitment_customer') {
          this.inboxCount = this.currentMenuCount.inboxRecruitmentCustomerCount || 0
          this.activeCount = this.currentMenuCount.activeRecruitmentCustomerCount || 0
        } else if (this.customerType === 'recruitment_professional') {
          this.inboxCount = this.currentMenuCount.inboxRecruitmentProfessionalCount || 0
          this.activeCount = this.currentMenuCount.activeRecruitmentProfessionalCount || 0
        } else if (this.customerType === 'recruitment_professional_secondary') {
          this.inboxCount = this.currentMenuCount.inboxRecruitmentProfessionalSecondaryCount || 0
          this.activeCount = this.currentMenuCount.activeRecruitmentProfessionalSecondaryCount || 0
        } else if (this.customerType === 'professional_secondary') {
          this.inboxCount = this.currentMenuCount.inboxProfessionalSecondaryCount || 0
          this.activeCount = this.currentMenuCount.activeProfessionalSecondaryCount || 0
        } else if (this.customerType === 'mari_customer') {
          this.inboxCount = this.currentMenuCount.inboxMariCustomerCount || 0
          this.activeCount = this.currentMenuCount.activeMariCustomerCount || 0
        } else if (this.customerType === 'mari_professional') {
          this.inboxCount = this.currentMenuCount.inboxMariProfessionalCount || 0
          this.activeCount = this.currentMenuCount.activeMariProfessionalCount || 0
        }
      }
    },
    // กดเมนูที่เลือกอยู่แล้ว = โหลดรายการใหม่ — ค่าเมนูไม่เปลี่ยน watcher ที่เป็นคนโหลดจึงไม่ทำงาน
    // เก็บตัวกรองที่ตั้งไว้ (แท็ก / แอดมิน / ค้นหา) ต่างจากการสลับเมนูที่ล้างตัวกรอง
    onMenuClick (menu) {
      if (menu === this.activeMenu) {
        this.$emit('onReloadMenu')
        return
      }
      this.loadConversations(menu)
    },
    loadConversations (menu, fromNavbar = false) {
      this.activeMenu = menu
      const params = {
        page: 0,
        menu: menu,
        customer_type: this.customerType
      }
      if (!fromNavbar) {
        params.main_menu = true
      }

      // ตัวกรอง admin ไม่ข้ามเมนู และ InboxToolbarV2026 เป็นเจ้าของสถานะนั้นที่เดียว
      // เดิมที่นี่สั่ง null ตอนสลับเมนู แต่ toolbar ยิง search ของตัวเองด้วยค่าที่ยังค้าง
      // = แหล่งความจริงสองที่ที่ขัดกันเอง
      params.admin_id = null

      this.fetchSystemTags({
        include_count: true,
        customer_type: this.customerType,
        menu: params.menu,
        main_menu: params.main_menu,
        system: 1
      })

      this.fetchParentChatTopics()
      if (fromNavbar) {
        this.$emit('onSearch', params)
      }
    },
    openDashboard () {
      let { href } = this.$router.resolve({
        path: '/dashboard'
      })
      window.open(href, '_blank', 'width=1080, height=768, scrollbars=yes, status=yes')
    },
    openPReport () {
      let { href } = this.$router.resolve({
        path: '/p-report'
      })
      window.open(href, '_blank', 'width=1080, height=768, scrollbars=yes, status=yes')
    }
  },
  sockets: {
    // หลุดแล้วต่อใหม่ = อาจพลาด event ช่วงนั้น → นับใหม่หนึ่งรอบ
    connect () {
      this.scheduleMyInboxCount()
    },
    newMessage (data) {
      this.checkMyInboxChange(data)
    },
    conversation (data) {
      this.checkMyInboxChange(data)
    }
  },
  mounted () {
    this.checkConversationCount()
    this.activeMenu = 'inbox'
    this.fetchMyInboxCount()
  },
  beforeDestroy () {
    clearTimeout(this.myInboxTimer)
  }
}
</script>

<style lang="scss" scoped>
.v2026-queue {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ffffff;
}

.v2026-queue-title {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
  font-size: 15px;
  font-weight: 600;
  color: #212529;
  border-bottom: 1px solid #e9ecef;
}

.v2026-queue-title-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.v2026-queue-collapse {
  flex: 0 0 auto;
  margin-left: auto;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
  line-height: 0;

  &:hover .v2026-queue-collapse-ico {
    background-color: #212529;
  }
}

.v2026-queue-collapse-ico {
  display: inline-block;
  width: 18px;
  height: 18px;
  background-color: var(--v2026-color-icon-idle);
  -webkit-mask: url('~@/assets/icons2026/arrow-right.svg') center / contain no-repeat;
  mask: url('~@/assets/icons2026/arrow-right.svg') center / contain no-repeat;

}

.v2026-queue-list {
  padding: 8px 0;
}

.v2026-queue-row {
  display: flex;
  align-items: center;
  gap: 14px;
  height: 50px;
  margin: 2px 8px;
  padding: 0 8px;
  border-radius: 8px;
  position: relative;
  font-size: 15px;
  cursor: pointer;

  &:hover {
    background: var(--v2026-color-hover-bg);
  }

  &.is-selected {
    background: var(--v2026-color-main-soft);

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 8px;
      bottom: 8px;
      width: 3px;
      border-radius: 0 2px 2px 0;
      background: var(--v2026-color-main-bar);
    }

    .v2026-queue-label,
    .v2026-queue-icon {
      color: var(--v2026-color-main-icon);
      font-weight: 600;
    }

    .v2026-queue-svg-mask {
      background-color: var(--v2026-color-main-icon);
    }
  }
}

.v2026-queue-icon {
  flex: 0 0 auto;
  width: 18px;
  text-align: center;
  font-size: 16px;
  color: var(--v2026-color-icon-idle);
}

.v2026-queue-avatar {
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
  margin: 0 -1px;
  border-radius: 50%;
  object-fit: cover;
}

.v2026-queue-svg-mask {
  flex: 0 0 auto;
  display: inline-block;
  width: 18px;
  height: 18px;
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-position: center;
          mask-position: center;
  -webkit-mask-size: contain;
          mask-size: contain;
  background-color: var(--v2026-color-icon-idle);
}

/* One line with "…" when the rail is narrow, like PanelSubTabBarV2026 — the title attr shows the full name. */
.v2026-queue-label {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #343a40;
}

.v2026-queue-count {
  flex: 0 0 auto;
  margin-left: 8px;
  padding: 0;
  background: none;
  border-radius: 0;

  color: var(--v2026-color-count);
  font-weight: 700;
  font-size: 13px;

  // งานของตัวเอง ไม่ใช่คิวค้าง — ใช้สีหลักแทนสีแดงเตือน
  &.is-mine {
    color: var(--v2026-color-main-icon);
  }

  // "รับเคสแล้ว": แดง (ยังไม่ได้อ่าน) อยู่ชิดซ้ายของฟ้า (ทั้งหมด)
  &.is-unread + & {
    margin-left: 6px;
  }

  // ตามหลัง pill รอเตือน — ชิดกว่าระยะจากชื่อเมนู
  .v2026-queue-upcoming + & {
    margin-left: 6px;
  }
}

// เตือนนัดหมายที่ยังไม่ถึงเวลา: pill เทาเล็ก ๆ อยู่หน้าตัวเลขแดง — ตัวเลขแดง (ถึงเวลาแล้ว) จึงยังอยู่คอลัมน์ขวาเดียวกับเมนูอื่น
.v2026-queue-upcoming {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin-left: 8px;
  padding: 1px 6px;
  border-radius: 999px;
  background: #f1f3f5;
  color: var(--v2026-color-icon-idle);
  font-size: 11px;
  font-weight: 600;
  line-height: 16px;

  i {
    font-size: 10px;
  }
}
</style>
